import React, { FC } from "react";

import { t } from "i18next";
import IconButton from "@mui/material/IconButton";

import { Body, Container, Header, StyledCloseIcon, StyledImage, StyledImageViewer, Title } from "./styled";

type ImageViewerProps = {
    title?: string;
    url: string | ArrayBuffer;
    onClose: () => void;
};

const ImageViewer: FC<ImageViewerProps> = ({ title, url, onClose }) => {
    return (
        <StyledImageViewer open data-testid="image-viewer">
            <Container>
                <Header>
                    <Title>{title}</Title>

                    <IconButton onClick={onClose} aria-label={t("Common.Close")}>
                        <StyledCloseIcon data-testid="image-viewer-close" />
                    </IconButton>
                </Header>
                <Body>
                    <StyledImage src={url as string} alt="" />
                </Body>
            </Container>
        </StyledImageViewer>
    );
};

export default ImageViewer;
